import styled from "styled-components";

export const ForgotParent = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #FBFAF9;
    `;

export const ForgotWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #FBFAF9;
    justify-content: center;
    align-items: center;
    justify-content: center;
    `;

export const FlContainer = styled.div`
display: flex;
flex-direction:column;
width:30%;
margin-left:5rem;

& img{
    width:15rem;
    margin-left:6rem;
    margin-bottom:2.5rem;
}
`;

export const ForgotContainer = styled.div`
   width: 30%;
   height: 60%;
   display: flex;
   flex-direction: column;
   background: #FFFFFF;
   justify-content: center;
   margin-left:5rem;
   border: 2px solid #F2F2F2;
   border-radius: 10px;

    & h1{
        align-items:center;
        margin-left:4rem;
        font-weight:450;
        line-height:0.2rem;
        font-size:1.3rem;
        margin-top:2rem;
    }
    & p{
      margin-left:3.5rem;
       font-size:0.8rem;
       line-height: 0.1rem;
    }
    `;

export const BoxContainer = styled.div`
   width: 90%;
   height: 100%;
   display: flex;
   flex-direction: column;
    background: #FFFFFF;
    justify-content: center;
    margin-left:4.7rem;

    
    `;

export const BtnWrapper = styled.div`
   margin-left:1rem;

    `;